import { useIntersectionObserver, type UseIntersectionObserverOptions } from '@vueuse/core'

export default function useLazyload(target: Ref<HTMLElement | null>, options: UseIntersectionObserverOptions = {}) {
  const isVisible = ref(false)
  const { stop } = useIntersectionObserver(
    target,
    ([entry], _observerElement) => {
      if (entry?.isIntersecting) {
        isVisible.value = true
        stop()
      }
    },
    options
  )

  return isVisible
}